import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle16() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article16" headerImage="solarcells.jpg" />
        <Footer />
    </div>
  )
}
